import { layoutTypes } from "../types";

const initialState = {
  openDrawer: false,
  loadingMain: false,
  showBreadCrums: true,
  title: "",
  params: {},
  isDSAMenu: false,
  isEVAMenu: false,
  appTitle: "THE GEAR",
  hiddenMenu: []
};

export function layout(state = initialState, action) {
  switch (action.type) {
    case layoutTypes.TOGGLE_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer,
      };
    case layoutTypes.SET_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: action.open,
      };
    case layoutTypes.TOGGLE_LOADING_MAIN:
      return {
        ...state,
        loadingMain: !state.loadingMain,
      };
    case layoutTypes.HIDE_BREADCRUMS:
      return {
        ...state,
        showBreadCrums: false,
      };
    case layoutTypes.SHOW_BREADCRUMS:
      return {
        ...state,
        showBreadCrums: true,
      };
    case layoutTypes.TITLE:
      return {
        ...state,
        title: action.title,
      };
    case layoutTypes.SUB_BREADCRUMBS:
      return {
        ...state,
        subBreadcrumb: action.subBreadcrumb,
      };
    case layoutTypes.SHOW_DSA_MENU:
      return {
        ...state,
        isDSAMenu: true,
      };
    case layoutTypes.HIDE_DSA_MENU:
      return {
        ...state,
        isDSAMenu: false,
      };
    case layoutTypes.SHOW_EVA_MENU:
      return {
        ...state,
        isEVAMenu: true,
      };
    case layoutTypes.HIDE_EVA_MENU:
      return {
        ...state,
        isEVAMenu: false,
      };
    case layoutTypes.SET_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...(action?.params || {}),
          // [action?.param?.key]: action?.param?.value
        },
      };
    case layoutTypes.CHANGE_APP_TITLE:
      return {
        ...state,
        appTitle: action.appTitle,
      };
    case layoutTypes.SET_HIDDEN_MENU:
      return {
        ...state,
        hiddenMenu: action?.params,
      };
    default:
      return state;
  }
}
